import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';

export const ARTICLE_SORT_OPTIONS = [
    { sortBy: 'lastModified', order: 'desc', label: 'Recently Updated', icon: 'bi-sort-down' },
    { sortBy: 'lastModified', order: 'asc', label: 'Oldest Updated', icon: 'bi-sort-up' },
    { sortBy: 'title', order: 'asc', label: 'Title A–Z', icon: 'bi-sort-alpha-down' },
    { sortBy: 'title', order: 'desc', label: 'Title Z–A', icon: 'bi-sort-alpha-up' },
    { sortBy: '', order: 'desc', label: 'Newest Created', icon: 'bi-clock-history' },
];

function ArticlesToolbar({
    searchTerm,
    onSearchTermChange,
    onSearch,
    onClearSearch,
    sortBy,
    sortOrder,
    onSortChange,
    totalElements,
    headingText,
}) {
    const [localSearch, setLocalSearch] = useState(searchTerm);

    useEffect(() => {
        setLocalSearch(searchTerm);
    }, [searchTerm]);

    const activeSort =
        ARTICLE_SORT_OPTIONS.find((option) => option.sortBy === sortBy && option.order === sortOrder) ||
        ARTICLE_SORT_OPTIONS[0];

    const handleSearchSubmit = () => {
        onSearchTermChange(localSearch);
        onSearch(localSearch);
    };

    const handleClear = () => {
        setLocalSearch('');
        onSearchTermChange('');
        onClearSearch();
    };

    return (
        <div className="ecx-page-toolbar articles-toolbar mb-3">
            <div className="d-flex flex-nowrap align-items-center gap-2 articles-toolbar__row">
                <div className="d-flex align-items-center gap-2 flex-shrink-0 articles-toolbar__heading">
                    <h5 className="mb-0 fw-normal text-dark text-truncate">{headingText}</h5>
                    <span className="ecx-page-chip flex-shrink-0">
                        <i className="bi bi-journal-text"></i>
                        {totalElements} article{totalElements === 1 ? '' : 's'}
                    </span>
                </div>

                <div className="input-group input-group-sm flex-grow-1 articles-toolbar__search min-width-0">
                    <span className="input-group-text bg-light border-end-0">
                        <i className="bi bi-search text-muted"></i>
                    </span>
                    <input
                        type="text"
                        className="form-control form-control-sm border-start-0 bg-light"
                        placeholder="Search by title..."
                        value={localSearch}
                        onChange={(e) => setLocalSearch(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleSearchSubmit();
                            }
                        }}
                    />
                    <button type="button" className="btn btn-sm btn-accent" onClick={handleSearchSubmit}>
                        Search
                    </button>
                    {(localSearch || searchTerm) && (
                        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={handleClear}>
                            Clear
                        </button>
                    )}
                </div>

                <Dropdown align="end" className="flex-shrink-0">
                    <Dropdown.Toggle
                        variant="outline-secondary"
                        size="sm"
                        className="d-flex align-items-center gap-2 articles-sort-toggle"
                    >
                        <i className={`bi ${activeSort.icon}`}></i>
                        <span className="d-none d-xl-inline">{activeSort.label}</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="shadow-sm" popperConfig={{ strategy: 'fixed' }} renderOnMount>
                        {ARTICLE_SORT_OPTIONS.map((option) => (
                            <Dropdown.Item
                                key={`${option.sortBy}-${option.order}`}
                                active={sortBy === option.sortBy && sortOrder === option.order}
                                onClick={() => onSortChange(option.sortBy, option.order)}
                            >
                                <i className={`bi ${option.icon} me-2`}></i>
                                {option.label}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </div>
    );
}

export default ArticlesToolbar;
